import { Box, Typography } from '@mui/material';
import CustomButton from 'components/shared/CustomButton/CustomButton';
import zeplinColor from 'theme/Color';
import Card from '../../Companies/Card';

const SimilarCompanies = ({ data }: { data: any }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        border: `1px solid ${zeplinColor.Neutral5}`,
        padding: '16px',
        gap: '12px',
        borderRadius: '14px',
        width: '100%',
        overflowY: 'scroll',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <Typography variant='responsiveHeading3'>Similar Companies</Typography>
        <CustomButton
          disabled={false}
          onClick={() => {
            // setValue(3);
          }}
          variant='text'
          color='secondary'
          style={{
            textAlign: 'center',
            gap: '16px',
          }}
          textStyle={{ color: zeplinColor.BasicBlack }}
          text={'See All'}
          icon={''}
          buttonVariant='buttonSmall'
        />
      </Box>
      {!data?.length ? (
        <NoSimilarCompanies />
      ) : (
        data.map((company: any) => <Card key={company.id} data={company} variant='small' />)
      )}
    </Box>
  );
};

export default SimilarCompanies;

const NoSimilarCompanies = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '32px',
      }}
    >
      {' '}
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          gap: '24px',
          width: '100%',
        }}
      >
        <img src={'/assets/no-zoominfo.svg'} />
        <Typography
          variant='responsiveHeading3'
          color={zeplinColor.BasicBlack}
          sx={{ marginTop: '0px' }}
        >
          No Similar companies.
        </Typography>
      </Box>
    </Box>
  );
};
